import axios from 'axios'
export default () => {
    return axios.create({
        baseURL: `https://admin.rgeahosa.org/api`,
        withCredentials: false,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
}


// baseURL: `http://72.167.222.249:8000/api`,
